export const LOCKED_SESSION_STATUS = 423;

export const getApiErrorStatus = (error: any): number | undefined => {
  const status = error?.status ?? error?.response?.status;

  if (typeof status === 'number') {
    return status;
  }

  if (typeof status === 'string') {
    const parsedStatus = Number(status);
    return Number.isNaN(parsedStatus) ? undefined : parsedStatus;
  }

  return undefined;
};

export const isLockedSessionError = (error: any): boolean => getApiErrorStatus(error) === LOCKED_SESSION_STATUS;
